import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { addGoodInventoryStockTake, updateGoodInventory, updateGoodsRecords, updateGoodSubType, updateGoodType } from "../functions/Goods";
import { getDateStringFromString, getDateString, sleep, getDateDifference, isDateValid } from "../functions/Utility";
import { Button, Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from "reactstrap";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import { el } from 'date-fns/locale';
import { keys } from '@material-ui/core/styles/createBreakpoints';

const useStyles = makeStyles({
    card: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    cover: {
        minWidth: 120,
        flex: '0.4 0 auto',
    }
});

function GoodStockTakeCard(props) {
    const classes = useStyles();
    const { goodSingleData, onCardClick, onUpdateStart, onUpdateEnd, finishStockTakeSingleGood, expandAllCard, goodTypeList, goodSubTypeList, cardIndex } = props;

    //  Inventory edit
    const newInventoryStockTakeInputRef = useRef(null);

    // part the data into parts
    const [inventoryData, setInventoryData] = React.useState({});
    const [inventoryStockTakeData, setInventoryStockTakeData] = React.useState({});
    const [pendingDeliveryQuantityData, setPendingDeliveryQuantityData] = React.useState({});

    // For user input and post to db
    const [newInventoryStockTakeValue, setNewInventoryStockTakeValue] = React.useState(0);
    const [newInventoryStockTakeValueIsEdited, setNewInventoryStockTakeValueIsEdited] = React.useState(false);
    const [newInventoryStockTakeValueIsError, setNewInventoryStockTakeValueIsError] = React.useState(false);

    // Control
    const [isFinishedStockTake, setIsFinishedStockTake] = React.useState(false);
    const [expandThisCard, setExpandThisCard] = React.useState(false);
    const [dropdownGoodTypeOpen, setDropdownGoodTypeOpen] = React.useState(false);
    const [dropdownGoodSubTypeOpen, setDropdownGoodSubTypeOpen] = React.useState(false);


    // Searching the dropdown menu
    const [goodTypeSearchValue, setGoodTypeSearchValue] = React.useState('');
    const [goodSubTypeSearchValue, setGoodSubTypeSearchValue] = React.useState('');

    // Display data
    const [displayGoodTypeList, setDisplayGoodTypeList] = React.useState([]);
    const [displayGoodSubTypeList, setDisplayGoodSubTypeList] = React.useState([]);


    // New Type new subtype
    const [enableNewTypeInput, setEnableNewTypeInput] = React.useState(false);
    const [enableNewSubTypeInput, setEnableNewSubTypeInput] = React.useState(false);
    const [newGoodTypeToAdd, setNewGoodTypeToAdd] = React.useState('');
    const [newGoodSubTypeToAdd, setNewGoodSubTypeToAdd] = React.useState('');


    React.useEffect(() => {
        if (goodSingleData.GoodInventories && Array.isArray(goodSingleData.GoodInventories)) {
            // assumption 
            // there will be only one inventory data in one sourceLocation
            setInventoryData(goodSingleData.GoodInventories[0]);
        } else {
            setInventoryData({});
        }

        if (goodSingleData.GoodInventoryStockTakeMostUpdates && Array.isArray(goodSingleData.GoodInventoryStockTakeMostUpdates)) {
            // assumption 
            // there will be only one inventory stock take data in one sourceLocation
            setInventoryStockTakeData(goodSingleData.GoodInventoryStockTakeMostUpdates[0]);
        } else {
            setInventoryStockTakeData({});
        }

        if (goodSingleData.PendingDeliveryQuantities && Array.isArray(goodSingleData.PendingDeliveryQuantities)) {
            // assumption 
            // there will be only one PendingDeliveryQuantity data in one sourceLocation
            setPendingDeliveryQuantityData(goodSingleData.PendingDeliveryQuantities[0]);
        } else {
            setPendingDeliveryQuantityData({});
        }
        setIsFinishedStockTake(goodSingleData.isFinishedStockTake);

    }, [goodSingleData]);

    React.useEffect(() => {
        // Defualt value for the stockTake input
        setNewInventoryStockTakeValue(inventoryData.inventory);
    }, [inventoryData]);

    React.useEffect(() => {
        setIsFinishedStockTake(goodSingleData.isFinishedStockTake);
    }, [goodSingleData.isFinishedStockTake]);

    React.useEffect(() => {
        setExpandThisCard(expandAllCard);
    }, [expandAllCard]);

    React.useEffect(() => {
        filterGoodTypeList();
    }, [goodTypeSearchValue]);

    React.useEffect(() => {
        filterGoodSubTypeList();
    }, [goodSubTypeSearchValue]);

    //  General data update function
    const onUpdateInventory = async () => {
        onUpdateStart();

        let pendingDeliveryQuantityToUse = 0;
        if (pendingDeliveryQuantityData && pendingDeliveryQuantityData.pendingDeliveryQuantity) {
            pendingDeliveryQuantityToUse = pendingDeliveryQuantityData.pendingDeliveryQuantity;
        } else {
            pendingDeliveryQuantityToUse = 0;
        }

        let newInventoryToSave = newInventoryStockTakeValue - pendingDeliveryQuantityToUse;
        await addGoodInventoryStockTake(goodSingleData.goodID, "CHORKEEMAT", inventoryData.inventory, newInventoryToSave, newInventoryStockTakeValue);
        await updateGoodInventory(goodSingleData.goodID, "CHORKEEMAT", newInventoryToSave, inventoryData.minInventory, inventoryData.maxInventory);

        finishStockTakeSingleGood(goodSingleData.goodID, "CHORKEEMAT");

        await sleep(200);


        onUpdateEnd();
    };

    const onUpdateGoodType = async (newGoodType) => {
        onUpdateStart();
        if (newGoodType && newGoodType != '') {
            let clearTextToUpdate = newGoodType.replace(/ /g, '');
            await updateGoodType(goodSingleData.goodID, clearTextToUpdate);
            await sleep(200);
            goodSingleData.goodType = clearTextToUpdate;
        }
        onUpdateEnd();
    };

    const onUpdateGoodSubType = async (newGoodSubType) => {
        onUpdateStart();
        if (newGoodSubType && newGoodSubType != '') {
            let clearTextToUpdate = newGoodSubType.replace(/ /g, '');
            await updateGoodSubType(goodSingleData.goodID, clearTextToUpdate);
            await sleep(200);
            goodSingleData.goodSubType = clearTextToUpdate;
        }
        onUpdateEnd();
    };


    const filterGoodTypeList = () => {
        let goodTypeListToFilter = [...goodTypeList];

        if (goodTypeListToFilter && Array.isArray(goodTypeListToFilter) && goodTypeListToFilter.length >= 0) {
            if (goodTypeSearchValue && goodTypeSearchValue !== '') {
                let cleanTextToSearch = goodTypeSearchValue.replace(/ /g, '').toLowerCase();

                let resultList = goodTypeListToFilter.filter(item =>
                    item.goodType.toLowerCase().includes(cleanTextToSearch));

                setDisplayGoodTypeList(resultList);
            } else {
                setDisplayGoodTypeList(goodTypeListToFilter);
            }
        } else {
            setDisplayGoodTypeList([]);
        }
    };

    const filterGoodSubTypeList = () => {
        let goodSubTypeListToFilter = [...goodSubTypeList];

        if (goodSubTypeListToFilter && Array.isArray(goodSubTypeListToFilter) && goodSubTypeListToFilter.length >= 0) {
            if (goodSubTypeSearchValue && goodSubTypeSearchValue !== '') {
                let cleanTextToSearch = goodSubTypeSearchValue.replace(/ /g, '').toLowerCase();

                let resultList = goodSubTypeListToFilter.filter(item =>
                    item.goodSubType.toLowerCase().includes(cleanTextToSearch));

                setDisplayGoodSubTypeList(resultList);

            } else {
                setDisplayGoodSubTypeList(goodSubTypeListToFilter);

            }
        } else {
            setDisplayGoodSubTypeList([]);
        }

    };


    return (
        <div className="mt-3">
            {/*overflow: 'visible' is for the dropdown menu to show outside the card */}
            <Card
                className={classes.card}
                style={{ overflow: 'visible', backgroundColor: isFinishedStockTake ? "Aquamarine" : "IndianRed" }}

            >

                <CardActionArea>
                    <Container>
                        <Row>
                            <CardContent className="col-10" onClick={() => {
                                onCardClick(goodSingleData);
                            }}>

                                <Typography variant="h5" component="h2">
                                    {`${cardIndex}.`}{goodSingleData.goodDescription}
                                </Typography>
                                <Typography variant="h6" component="h3">
                                    $ {goodSingleData.goodDefaultUnitPrice} / {goodSingleData.goodDefaultUnitQuantity}{goodSingleData.goodUnit}
                                </Typography>
                                <Typography color="textSecondary">
                                    {goodSingleData.goodDefaultWeight} kg / {goodSingleData.goodDefaultUnitQuantity}{goodSingleData.goodUnit}
                                </Typography>
                                {(inventoryStockTakeData?.stockTakeDateTime) &&
                                    <Typography className={""} color="textSecondary">
                                        {'點貨時間：'}{getDateString(inventoryStockTakeData?.stockTakeDateTime, true)}
                                    </Typography>
                                }
                                {(inventoryStockTakeData?.stockTakeDateTime) &&
                                    <Typography className={""} color="textSecondary">
                                        {'距離：'}{getDateDifference(new Date(inventoryStockTakeData?.stockTakeDateTime), new Date, "hour")}{'小時前'}
                                    </Typography>
                                }
                                <Typography className={'d-flex mt-2'} color="textSecondary">

                                    <Dropdown className="mr-2"
                                        isOpen={dropdownGoodTypeOpen}
                                        toggle={(e) => {
                                            if (e instanceof PointerEvent) {
                                                // Pointer event is triggered when 
                                                // user try to input a space bar in the input
                                            } else {
                                                e.preventDefault();
                                                setDropdownGoodTypeOpen(!dropdownGoodTypeOpen);
                                            }
                                        }}

                                    >
                                        <DropdownToggle caret color="warning">
                                            {goodSingleData.goodType}
                                        </DropdownToggle>
                                        <DropdownMenu className='customer-dropdown-menu' >
                                            <div className='d-flex'>
                                                <Input
                                                    className='ml-2 mr-2'
                                                    type="text"
                                                    placeholder="搜尋..."
                                                    value={goodTypeSearchValue}
                                                    onChange={(e) => setGoodTypeSearchValue(e.target.value)}
                                                />
                                            </div>

                                            {displayGoodTypeList.map((goodTypeItem) => {
                                                //  return <DropdownItem onClick={() => onCarIdDropdownSelect(car.carID)}>{car.carID}</DropdownItem>;
                                                return <DropdownItem onClick={() => { onUpdateGoodType(goodTypeItem.goodType) }}>{goodTypeItem.goodType}</DropdownItem>;
                                            })}


                                            <Button
                                                className="mx-1 my-1"
                                                color='info' onClick={() => {
                                                    setEnableNewTypeInput(!enableNewTypeInput)
                                                }}>
                                                <i className="fas fa-plus" />
                                                新增貨物種類
                                            </Button>

                                            {enableNewTypeInput &&
                                                <>
                                                    <div className='d-flex'>
                                                        <Input
                                                            className='ml-2 mr-2'
                                                            type="text"
                                                            placeholder="新增"
                                                            value={newGoodTypeToAdd}
                                                            onChange={(e) => setNewGoodTypeToAdd(e.target.value)}
                                                        />

                                                    </div>
                                                    <Button
                                                        className="mx-1 my-1"
                                                        color='success' onClick={() => {
                                                            onUpdateGoodType(newGoodTypeToAdd);
                                                            setDropdownGoodTypeOpen(!dropdownGoodTypeOpen); // manually close the dropdown
                                                        }}>
                                                        <i className="fas fa-plus" />
                                                        確定
                                                    </Button>
                                                </>
                                            }
                                        </DropdownMenu>
                                    </Dropdown>

                                    <Dropdown className="mr-2" isOpen={dropdownGoodSubTypeOpen}
                                        toggle={(e) => {
                                            if (e instanceof PointerEvent) {
                                                // Pointer event is triggered when 
                                                // user try to input a space bar in the input
                                                // console.log('Pointer event triggered');
                                            } else {
                                                e.preventDefault();
                                                setDropdownGoodSubTypeOpen(!dropdownGoodSubTypeOpen);
                                            }

                                        }}
                                    >
                                        <DropdownToggle caret color="warning">
                                            {goodSingleData.goodSubType}
                                        </DropdownToggle>
                                        <DropdownMenu className='customer-dropdown-menu' >

                                            <div className='d-flex'>
                                                <Input
                                                    className='ml-2 mr-2'
                                                    type="text"
                                                    placeholder="搜尋..."
                                                    value={goodSubTypeSearchValue}
                                                    onChange={(e) => setGoodSubTypeSearchValue(e.target.value)}
                                                />
                                            </div>
                                            {displayGoodSubTypeList.map((goodSubTypeItem) => {
                                                //  return <DropdownItem onClick={() => onCarIdDropdownSelect(car.carID)}>{car.carID}</DropdownItem>;
                                                return <DropdownItem onClick={() => { onUpdateGoodSubType(goodSubTypeItem.goodSubType) }}>{goodSubTypeItem.goodSubType}</DropdownItem>;
                                            })}

                                            <Button
                                                className="mx-1 my-1"
                                                color='info' onClick={(e) => {
                                                    e.preventDefault();
                                                    setEnableNewSubTypeInput(!enableNewSubTypeInput)
                                                }}>
                                                <i className="fas fa-plus" />
                                                新增貨物明細種類
                                            </Button>

                                            {enableNewSubTypeInput &&
                                                <>
                                                    <div className='d-flex'>
                                                        <Input
                                                            className='ml-2 mr-2'
                                                            type="text"
                                                            placeholder="新增"
                                                            value={newGoodSubTypeToAdd}
                                                            onChange={(e) => setNewGoodSubTypeToAdd(e.target.value)}
                                                        />

                                                    </div>
                                                    <Button
                                                        className="mx-1 my-1"
                                                        color='success'
                                                        onClick={() => {
                                                            onUpdateGoodSubType(newGoodSubTypeToAdd);
                                                            setDropdownGoodSubTypeOpen(!dropdownGoodSubTypeOpen); // manually close the dropdown
                                                        }}>
                                                        <i className="fas fa-plus" />
                                                        確定
                                                    </Button>
                                                </>
                                            }
                                        </DropdownMenu>
                                    </Dropdown>

                                </Typography>


                                {expandThisCard &&
                                    <Typography className='mt-2'  >

                                        <Typography className={classes.pos} color="textSecondary">
                                            {goodSingleData.goodRemark}
                                        </Typography>
                                    </Typography>
                                }
                            </CardContent>
                            <CardContent className="col-2 px-0">
                                <Button
                                    className='mx-1 my-1'
                                    color='info'
                                    onClick={() => {
                                        setExpandThisCard(!expandThisCard);
                                    }}
                                >
                                    <i className={`fa fa-caret-${expandThisCard ? "up" : "down"}`} />
                                </Button>

                            </CardContent>
                        </Row>

                    </Container>
                </CardActionArea>

                {expandThisCard &&
                    <CardActions>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>存貨</InputGroupText>
                            </InputGroupAddon>
                            <Input
                                readOnly={true}
                                style={{}}
                                type="text"
                                inputMode="decimal"
                                value={inventoryData.inventory}
                                onChange={(e) => {
                                }} />
                            <InputGroupAddon addonType="append">
                                <InputGroupText>{goodSingleData.goodUnit}</InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </CardActions>

                }

                {expandThisCard &&
                    <CardActions>
                        <InputGroup>
                            <InputGroupAddon addonType="prepend">
                                <InputGroupText>留貨</InputGroupText>
                            </InputGroupAddon>
                            <Input
                                readOnly={true}
                                style={{}}
                                type="text"
                                inputMode="decimal"
                                value={pendingDeliveryQuantityData ? pendingDeliveryQuantityData.pendingDeliveryQuantity : 0}
                                onChange={(e) => {
                                }} />
                            <InputGroupAddon addonType="append">
                                <InputGroupText>{goodSingleData.goodUnit}</InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </CardActions>

                }
                <CardActions>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText>點貨</InputGroupText>
                        </InputGroupAddon>
                        <Input ref={newInventoryStockTakeInputRef}
                            style={newInventoryStockTakeValueIsError ? { color: "#c13637", borderColor: "#c13637" } : {}}
                            type="text"
                            inputMode="decimal"
                            value={newInventoryStockTakeValue}
                            onClick={(e) => {
                                // For user experience
                                setNewInventoryStockTakeValue('');
                            }}
                            onChange={(e) => {
                                let inputString = e.target.value.replace(/ /g, '');
                                if (inputString === "" || isNaN(inputString)) { // isNaN not a number
                                    setNewInventoryStockTakeValueIsError(true);
                                } else {
                                    setNewInventoryStockTakeValueIsError(false);
                                }
                                setNewInventoryStockTakeValueIsEdited(true);
                                setNewInventoryStockTakeValue(inputString); // allow ''
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    // User experience
                                    // press Enter to confirm the change
                                    onUpdateInventory();
                                    setNewInventoryStockTakeValueIsEdited(false);
                                }
                            }}
                        />
                        {(newInventoryStockTakeInputRef.current !== null && newInventoryStockTakeValueIsEdited === true && newInventoryStockTakeValueIsError === false) ?
                            <InputGroupAddon addonType="append">
                                <Button color="success" onClick={async () => {
                                    await onUpdateInventory();
                                    setNewInventoryStockTakeValueIsEdited(false);
                                }}>
                                    <i className="fas fa-check" />
                                </Button>
                            </InputGroupAddon> : ""
                        }
                        <InputGroupAddon addonType="append">
                            <InputGroupText>{goodSingleData.goodUnit}</InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                </CardActions>

                {expandThisCard &&

                    <CardActionArea >
                        <Container>
                            <Row>
                                {/* <CardContent className="col-12">
                                    {(inventoryStockTakeData?.stockTakeDateTime) &&
                                        <Typography className={classes.pos} color="textSecondary">
                                            {getDateString(inventoryStockTakeData?.stockTakeDateTime, true)}
                                        </Typography>
                                    }
                                    {(inventoryStockTakeData?.stockTakeDateTime) &&
                                        <Typography className={classes.pos} color="textSecondary">
                                            {getDateDifference(new Date(inventoryStockTakeData?.stockTakeDateTime), new Date, "hour")}{'小時前'}
                                        </Typography>
                                    }


                                </CardContent> */}

                            </Row>
                        </Container>
                    </CardActionArea>
                }
            </Card>
        </div>
    );
}

export default GoodStockTakeCard
